import { isAfisCyprus, regionTitle } from 'shared-pages/common/constants';
import { Field } from 'formik';
import i18next from 'i18next';
import { CustomSelectComponent, FsProps } from 'motion-components';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export enum XAxisValues {
  Materials = 1,
  Region = 2,
  Date = 3,
}

export const FieldSelectXAxis = ({
  label = i18next.t('Αθροίσματα ανά (x-άξονας)'),
  name = 'xAxisId',
  disable = false,
  ...rest
}: FsProps & { readonly disable?: boolean }) => {
  const { t, i18n } = useTranslation();
  //
  const options = [
    { value: 1, label: t('Υλικό') },
    { value: 2, label: t(regionTitle) },
    { value: 3, label: t('Ημέρα') },
  ];

  return (
    <Field
      className="mb-2"
      name={name}
      title={label}
      component={CustomSelectComponent}
      options={options}
      isDisabled={disable}
      as={Row}
    />
  );
};
